import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningLead } from '../components/OpeningLead';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { FAQ } from '../components/FAQ';
import { StickyCTA } from '../components/StickyCTA';
import { CTAButton } from '../components/CTAButton';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/20" data-id="element-183">
      <Hero data-id="element-184" />
      <OpeningLead data-id="element-185" />
      <ProblemSection data-id="element-186" />
      <SolutionSection data-id="element-187" />
      <WhatYouGet data-id="element-188" />
      <FAQ data-id="element-189" />

      {/* Final Close */}
      <section id="pricing" className="py-20 px-6 text-center bg-cream-dark" data-id="element-190">
        <div className="max-w-2xl mx-auto" data-id="element-191">
          <h2 className="font-serif text-3xl md:text-4xl text-brown mb-6" data-id="element-192">
            You can love your baby and still need your body back.
          </h2>
          <p className="text-lg text-brown-light mb-10" data-id="element-193">
            If you're nap-trapped today, download{' '}
            <strong data-id="element-194">The Nap‑Trapped Reset</strong> and run the plan once.{' '}
            <br className="hidden md:block" data-id="element-195" />
            No perfection. No ideology. Just your next window.
          </p>
          <CTAButton text="Get the Reset" price="$6.39" originalPrice="$19.97" discountLabel="68% OFF" className="w-full md:w-auto min-w-[300px]" data-id="element-196" />
          <p className="mt-6 text-sm text-brown-light/60" data-id="element-197">
            Secure payment · Instant PDF delivery
          </p>
        </div>
      </section>

      <Footer data-id="element-198" />

      <StickyCTA data-id="element-199" />
    </div>;
}